import React from 'react';

import { navigate } from 'gatsby';
import styled from 'styled-components';
import PropTypes from 'prop-types';

import Fade from 'react-reveal/Fade';
import swal from 'sweetalert';
import { GraphQLClient, gql } from 'graphql-request';

import config from '../../utils/config';
import { Subtitle } from '../elements';
import QuoteForm from '../forms/QuoteForm';

const Section = styled.section`
  background: linear-gradient(0deg, rgba(0, 0, 0, 0.5), rgba(0, 0, 0, 0.5)),
    url(${(props) => props.image});
  background-position: center;
  background-size: cover;
`;

const client = new GraphQLClient(config.apiUrl, {
  timeout: 60000,
});

const contactUsMutation = gql`
  mutation contact($input: ContactInput) {
    contact(input: $input) {
      status
      message
    }
  }
`;

const QuoteHero = ({ title, description, image, isShowForm }) => {
  const handleSubmit = async (formData) => {
    const variables = { input: formData };

    await client
      .request(contactUsMutation, variables)
      .then((data2) => {
        if (data2) {
          navigate('/thank-you/');
        }
      })
      .catch((error) => {
        swal('Success!', error, 'success');
      });
  };

  return (
    <Section
      className="section is-medium"
      image={image && image.asset && image.asset.url}
    >
      <div className="container">
        <div className="columns">
          <div className="column is-6">
            <Fade left>
              {title && (
                <h1 className="title is-1 mb-4 has-text-white">{title}</h1>
              )}
              {description && (
                <Subtitle className="mt-5">{description}</Subtitle>
              )}
            </Fade>
          </div>
          {isShowForm && (
            <div className="column is-6">
              <QuoteForm onSubmit={(val) => handleSubmit(val)} />
            </div>
          )}
        </div>
      </div>
    </Section>
  );
};

QuoteHero.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  image: PropTypes.object,
};

QuoteHero.defaultProps = {
  title: '',
  description: '',
  image: {},
};

export default QuoteHero;
